import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="bg-forest-green py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <FadeIn data-id="element-50">
          <div className="border-4 border-gold p-8 md:p-12 rounded-2xl bg-forest-green text-center relative" data-id="element-51">
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-forest-green px-4" data-id="element-52">
              <ShieldCheck className="w-20 h-20 text-gold" data-id="element-53" />
            </div>

            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mt-8 mb-8" data-id="element-54">
              14-DAY MONEY BACK GUARANTEE
            </h2>

            <div className="space-y-6 text-lg text-gray-200 leading-relaxed" data-id="element-55">
              <p data-id="element-56">
                If after following the complete protocol for 7 days you notice
                no difference in your morning stiffness or joint pain, you have
                14 days from your purchase to request a full refund.
              </p>
              <p data-id="element-57">
                No complicated forms. No waiting. Just write to us at{' '}
                <a href="mailto:support@vitalyforms.com" className="text-gold hover:underline font-medium" data-id="element-58">
                  support@vitalyforms.com
                </a>{' '}
                and we process your refund in less than 48 hours.
              </p>
              <p className="font-medium text-white italic" data-id="element-59">
                That's how confident we are that this works.
              </p>
              <p className="font-serif text-gold pt-4" data-id="element-60">
                — The VitalyForms Research Team
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}